import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import SegmentView from '../../containers/segment/View';
import SegmentSideListItems from '../../containers/segment/side/ListItems';
import SegmentSideListAddButton from '../../containers/segment/side/ListAddButton';
import SegmentUpdatePaneContainer from './update/PaneContainer';
import SegmentExecutionPaneContainer from './execution/PaneContainer';
import { scrollToActiveElement } from '../../utils/compound';
import SimpleNavigationBar from '../navigation/SimpleNavigationBar';

const SegmentContainer = ({ tenantId, selectedSegment, isSegmentsTabOpen }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isSegmentsTabOpen) {
      navigate(`/${tenantId}/segments/execution/${selectedSegment.id}`);
      setTimeout(
        () => scrollToActiveElement({ block: 'nearest', inline: 'nearest', behavior: 'instant' }),
        0
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSegmentsTabOpen]);

  return (
    <>
      <SimpleNavigationBar />
      <SegmentView>
        <SegmentSideListItems tenantId={tenantId} navigate={navigate}>
          <SegmentSideListAddButton tenantId={tenantId} />
        </SegmentSideListItems>
        <Routes>
          <Route path="/add" element={<SegmentUpdatePaneContainer navigate={navigate} />} />
          <Route path="/update/:id" element={<SegmentUpdatePaneContainer navigate={navigate} />} />
          <Route
            path="/execution/:id"
            element={<SegmentExecutionPaneContainer tenantId={tenantId} />}
          />
        </Routes>
      </SegmentView>
    </>
  );
};

export default SegmentContainer;
